// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__S2ArP","tab":"styles_tab__Hu7I8","active":"styles_active__xvFFy"};